import { useState, useEffect } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import translator from '@Components/Utilities/Translator';
import TranslationText from '@Components/Utilities/TranslationText';
import ConditionalWrapper from '@Components/Utilities/ConditionalWrapper';
import { watchlistOnClick } from '@Components/Utilities/SandhillsWatchlist';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { maxImageCount, gtmEventType } from '@Components/Utilities/SandhillsConstants';
import { useRecoilValue } from 'recoil';
import { useWindowSize } from '@Components/Utilities/WindowSize';
import { gtmAlertPushEvent, sandhillsRequest, gtmPushEvent } from '@Components/Utilities/SandhillsUtility';
import LoadingRing from '@Components/MuiWrappers/LoadingRing';

const ListingImage = (props) => {

    const currentSite = useRecoilValue(atoms.currentWebsite);
    const [imageLoaded, setImageLoaded] = useState(props.ForceLoadImages || !props.LazyLoad);
    const showRetailPrice = props.ShowRetailPrice == null ? true : props.ShowRetailPrice;
    const [updateStatus, setUpdateStatus] = useState(true);
    const [dataAction, setDataAction] = useState('add');
    const [isSavedToWatchlist, setIsSavedToWatchlist] = useState(props.IsWatchlist && !props.IsRecommendedListingListSearch ? props.IsWatchlist : false);
    const isInEditorMode = useRecoilValue(atoms.isInTranslationEditor);
    const routes = useRecoilValue(atoms.routes);
    const currentUser = useRecoilValue(atoms.currentUser);
    const [activeIndex, setActiveIndex] = useState(0);
    const [touchStart, setTouchStart] = useState(null);
    const [touchEnd, setTouchEnd] = useState(null);
    const [hasSentImpression, setHasSentImpression] = useState(false);
    const [movingRight, setMovingRight] = useState(false);
    const [movingLeft, setMovingLeft] = useState(false);
    const windowSize = useWindowSize();
    const [styleLeft, setStyleLeft] = useState({ transform: '' });
    const [styleRight, setStyleRight] = useState({ transform: '' });
    const [styleMiddle, setStyleMiddle] = useState({ transform: '' });
    const [showLoadingRing, setShowLoadingRing] = useState(false);

    useEffect(() => {
        if (props.UserWatchlist && props.UserWatchlist.length > 0) {
            if ((props.UserWatchlist.filter(c => c.ListingId == props.ListingId || c.Id == props.ListingId).length > 0) && updateStatus) {
                setWatchListAction(true);
            } else if (props.unsaveWatchlist) {
                setIsSavedToWatchlist(false);
                if (props.setSavedToWatchlist) {
                    props.setSavedToWatchlist(false);
                }
                setWatchListAction(false);
            }
        }
    }, [props.UserWatchlist, props.unsaveWatchlist]);

    useEffect(function imageEffect() {
        if (imageLoaded) {
            props.DispatchListings?.({
                type: 'update-listing',
                payload: {
                    Id: props.ListingId,
                    ImagesLoaded: true,
                }
            });
        }
    }, [imageLoaded]);

    const minSwipeDistance = 50

    const onTouchStart = (e) => {
        setTouchEnd(null); // otherwise the swipe is fired even with usual touch events
        setTouchStart(e.targetTouches[0].clientX);
    }

    const onTouchMove = (e) => {
        setTouchEnd(e.targetTouches[0].clientX);

        if (!touchStart || !touchEnd) return
        const distance = touchStart - touchEnd;
        if (Math.abs(distance) > 10) {
            $("body").addClass("disable-scroll");
        }
        const width = windowSize.width;
        const isLeftSwipe = distance > 0;
        const isRightSwipe = distance < 0;
        let percentage = Math.abs(distance) / width * 100;

        if (isLeftSwipe && activeIndex + 1 < props.ImageUrl.length) {
            let mobileRightPercent = ('-' + percentage.toString() + '%');
            setStyleLeft('0%');
            setStyleRight(mobileRightPercent);
            setStyleMiddle(mobileRightPercent);
        } else if (isRightSwipe && activeIndex > 0) {
            let mobileLeftPercent = (percentage.toString() + '%');
            setStyleRight('0%');
            setStyleLeft(mobileLeftPercent);
            setStyleMiddle(mobileLeftPercent);
        }
    };

    const onTouchEnd = () => {
        const width = windowSize.width;
        if (!touchStart || !touchEnd) return
        const distance = touchStart - touchEnd;
        const isLeftSwipe = distance > minSwipeDistance;
        const isRightSwipe = distance < -minSwipeDistance;
        $("body").removeClass("disable-scroll");
        let percentage = Math.abs(distance) / width * 100;

        if (isLeftSwipe && (activeIndex + 1) < props.ImageUrl.length && (!windowSize.isMobile || percentage > 3)) {
            changeImage(activeIndex + 1);
            setStyleRight('-100%');
            setStyleMiddle('-100%');
        } else if (isRightSwipe && activeIndex > 0 && (!windowSize.isMobile || percentage > 3)) {
            changeImage(activeIndex - 1);
            setStyleLeft('100%');
            setStyleMiddle('100%');
        } else {
            setStyleLeft('0%');
            setStyleRight('0%');
            setStyleMiddle('0%');
        };
    }

    const getHeaderText = () => {
        if (props.HeaderText) {
            return props.HeaderText;
        } else {
            return '\u00A0';
        }
    };

    const watchlistClick = () => {
        if (props.UserWatchlist.filter(c => c.ListingId == props.ListingId || c.Id == props.ListingId).length < 1 || props.unsaveWatchlist) {
            watchlistOnClick(dataAction, props.ListingId, props.ListingTypes, routes);
            setWatchListAction(dataAction == 'add');
        }

        props.toggleWatchlistExpansion();
    };

    const setWatchListAction = (isSaved) => {
        setIsSavedToWatchlist(isSaved);
        if (props.setSavedToWatchlist) {
            props.setSavedToWatchlist(isSaved);
        }
        setUpdateStatus(false);
        setDataAction(isSaved ? 'delete' : 'add');
    };

    const getBrandingHeader = () => {
        if (!props.ShowAuctionBranding)
            return <></>;

        let className = 'listing-image-header';
        let image = <></>;
        let imageSrc;
        if (props.IsEF) {
            if (currentSite?.Site?.IsLivestockMarket || currentSite?.Site?.IsEquineMarket) {
                className += ' siteColorLSM';
                imageSrc = routes.CDNBaseUrl + 'Images/Icons/Miscellaneous/production-sale.png';
            } else {
                className += ' EF';
                imageSrc = routes.CDNBaseUrl + 'Images/Icons/Miscellaneous/ef-icon-black.png';
            }
        }
        else if (props.IsAT) {
            className += ' AT';
            imageSrc = routes.CDNBaseUrl + 'Images/Icons/Miscellaneous/at-icon-white.png';
        }

        if (imageSrc)
            image = {
                src: imageSrc, alt: '', width: '10', height: '12'
            };

        let headerText = '\u00A0';
        if (props.HeaderText)
            headerText = props.HeaderText;

        return <div className={className} >
            {imageSrc ? <LazyLoadImage {...image} /> : <></>}
            {isInEditorMode ? <div dangerouslySetInnerHTML={{ __html: headerText }}></div> : headerText}
        </div>;
    }


    const getLeftFlavor = () => {
        let text = '';
        let name = '';

        if (props.IsAT && props.ShowAuctionBranding) {
            if (props.HeaderText.includes(translator.translate('sandhills.featured'))) {
                text = translator.translate('sandhills.featured') + ' ';
            }
            text += translator.translate('sandhills.tradepubwebsite.mvc.onlineauction');

            name = 'at';
        } else if (props.ShowAuctionBranding && props.IsEF) {
            if (props.HeaderText) {
                text = props.HeaderText;
            }
            else {
                text += translator.translate('sandhills.tradepubwebsite.mvc.onsiteauction');
            }

            if (currentSite?.Site?.IsLivestockMarket || currentSite?.Site?.IsEquineMarket) {
                name = 'siteColorLSM';
            } else {
                name = 'ef';
            }
        } else if (props.IsPreAuction) {
            text = translator.translate('sandhills.preauctiontime');
            name = 'pre-at';
        } else if (props.IsFeaturedListing) {
            text = translator.translate('sandhills.tradepubwebsite.mvc.featuredlisting');
            name = 'feat';
        } else if (props.IsPremiumListing) {
            text = translator.translate('sandhills.premiumlisting');
            name = 'prem';
        } else if (props.ShowMediaOverlayBanner) {
            text = props.MediaOverlayBanner
            name = 'equipment-status';
        }
        if (text && name && name != 'equipment-status' && props.ShowMediaOverlayBanner) {
            return (
                <>
                    <span className={'left-flavor ' + name}>{text}</span>
                    <span className='left-flavor-bottom'>{props.MediaOverlayBanner}</span>
                </>
            );
        }
        else if (text && name) {
            return (
                <span className={'left-flavor ' + name}>{text}</span>
            );
        }
        return '';
    }

    const getWatchlistButton = () => {
        return (
            <>
                {!currentSite.Site.IsAircraft && !currentSite?.Site?.IsHostedSite &&
                    (props.IsCarouselRecommendedListing ?
                        <a role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); watchlistClick(); } }} aria-label={isSavedToWatchlist ? translator.translate('sandhills.removefromwatchlistwithspace') : translator.translate('sandhills.addtowatchlistwithspace')} title={isSavedToWatchlist ? translator.translate('sandhills.removefromwatchlistwithspace') : translator.translate('sandhills.addtowatchlistwithspace')} className={'ts-button listings-watchlist-lnk ' + (isSavedToWatchlist ? 'watchlist-delete' : 'watchlist-add')} data-listing-id={props.ListingId} data-action={(isSavedToWatchlist ? 'delete' : 'add')} onClick={watchlistClick}>
                            <i aria-hidden={true} className='far fa-heart'></i>
                            <i aria-hidden={true} className='fas fa-heart'></i>
                        </a> :
                        <button aria-label={isSavedToWatchlist ? translator.translate('sandhills.removefromwatchlistwithspace') : translator.translate('sandhills.addtowatchlistwithspace')} title={isSavedToWatchlist ? translator.translate('sandhills.removefromwatchlistwithspace') : translator.translate('sandhills.addtowatchlistwithspace')} className={'ts-button listings-watchlist-lnk ' + (isSavedToWatchlist ? 'watchlist-delete' : 'watchlist-add')} data-listing-id={props.ListingId} data-action={(isSavedToWatchlist ? 'delete' : 'add')} onClick={watchlistClick}>
                            <i aria-hidden={true} className='far fa-heart'></i>
                            <i aria-hidden={true} className='fas fa-heart'></i>
                        </button>
                    )
                }
            </>
        );
    };

    const changeImage = (image) => {
        if (image > activeIndex) {
            setMovingRight(true);
            setMovingLeft(false);
        } else {
            setMovingRight(false);
            setMovingLeft(true);
        }
        var imageObj = new Image();
        imageObj.src = props.ImageUrl[image];
        if (!imageObj.complete) {
            setImageLoaded(false);
            setShowLoadingRing(true);
        };
        gtmAlertPushEvent(gtmEventType.imageChange);
        if (!hasSentImpression && image == 1 && props.BaseCategoryId && props.ListingId) {
            // only send the impression once
            setHasSentImpression(true);
            sandhillsRequest({
                url: routes.ImageImpression,
                method: 'post',
                data: {
                    ListingID: props.ListingId,
                    baseCatID: props.BaseCategoryId,
                    HSPub: currentUser.HSTrackingUserID
                }
            })
        }
        setTimeout(() => {
            setActiveIndex(image);
            setMovingLeft(false);
            setMovingRight(false);
            setStyleLeft('0%');
            setStyleRight('0%');
            setStyleMiddle('0%');
        }, 525);
    }

    return (
        (props.IsPrintEventSaleCatalog || props.IsPrintListPage ?
            <section>
                <div className='print-listing-image'>
                    <a href={props.DetailUrl} target={props.LinkTarget} aria-label={translator.translate('sandhills.tradepubwebsite.mvc.viewdetailsfor') + " " + props.AltText ? props.AltText : props.ListingTitle + " - " + props.ListingId}>
                        <img onLoad={() => setImageLoaded(true)} src={props.ImageUrl[0]} className={'print-listing-main-image'} alt={props.AltText ? props.AltText : props.ListingTitle} />
                    </a>
                </div>
            </section>
            :
            <section>
                <div className='listing-image'>
                    {(!props.IsCarouselRecommendedListing && !props.IsDetailRecommendedListing) ? getBrandingHeader() : getLeftFlavor()}
                    <div className='listing-image-container' onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={onTouchEnd}>
                        {showLoadingRing && (
                             <LoadingRing sxBox={{pointerEvents: 'none', position: 'absolute', width: '100%', height: !props.IsParts ? '220px' : props.IsParts ? '135px' : '200px', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 10, }} />
                        )}
                        {props.ShowMediaOverlayBanner && !props.IsDetailRecommendedListing &&
                            <span className='listing-media-overlay-banner'>
                                <strong className={'media-overlay-banner'}>{props.MediaOverlayBanner}</strong>
                            </span>}
                        {(props.IsCarouselRecommendedListing) ?
                            <>
                                {getWatchlistButton()}
                                <a aria-label={translator.translate('sandhills.tradepubwebsite.mvc.viewdetails')} href={props.DetailUrl} target={props.LinkTarget} onClick={() => gtmPushEvent(gtmEventType.recommendedListingClick)}>
                                    <div className={props.ShowBlur && props.LazyLoad && !props.ForceLoadImages ? 'listing-image-blur' : 'listing-image-main'} aria-hidden='true'>
                                        {(props.ShowBlur && props.LazyLoad && !props.ForceLoadImages) ?
                                            <LazyLoadImage className='listing-main-image' src={props.ImageUrl[0]} alt={props.AltText ? props.AltText : props.ListingTitle} onLoad={() => setShowLoadingRing(false)} /> :
                                            <img src={props.ImageUrl[0]} className={'listing-main-image'} alt={props.AltText ? props.AltText : props.ListingTitle} onLoad={() => setShowLoadingRing(false)} />}
                                    </div>
                                </a>
                            </>
                            :
                            {
                                ...props.ImageUrl.length > 1 ?
                                    <>
                                        <div className='listing-image-blur' aria-hidden={activeIndex == maxImageCount ? false : true}>
                                            {activeIndex == maxImageCount ?
                                                <>
                                                    <a href={props.DetailUrl} target={props.LinkTarget} aria-label={props.AltText} className='view-all' onClick={(e) => { gtmAlertPushEvent(gtmEventType.viewAllImagesClick) }}>{translator.translate('sandhills.seeall')} {props.ImageCount} {translator.translate('sandhills.photos')}</a>
                                                    <span className='max-image' onClick={(e) => { gtmAlertPushEvent(gtmEventType.viewAllImagesClick) }}>
                                                        <img onLoad={() => { setImageLoaded(true); setShowLoadingRing(false); }} src={props.ImageUrl[activeIndex]} className={'listing-main-image disabled'} alt={props.AltText ? props.AltText : props.ListingTitle} />
                                                    </span>
                                                </> :
                                                {
                                                    ...props.ShowBlur && props.LazyLoad && !props.ForceLoadImages ?
                                                        <LazyLoadImage className='listing-main-image' src={props.ImageUrl[activeIndex]} alt={props.AltText ? props.AltText : props.ListingTitle} onLoad={() => setShowLoadingRing(false)} />
                                                        : <img onLoad={() => { setImageLoaded(true); setShowLoadingRing(false); }} src={props.ImageUrl[activeIndex]} className={'listing-main-image'} alt={props.AltText ? props.AltText : props.ListingTitle} />
                                                }
                                            }
                                        </div>
                                        <span className='arrow-container'>
                                            {activeIndex > 0 && <i className='fas fa-chevron-left arrow arrow-left' aria-label={translator.translate('sandhills.previmage')} role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); changeImage(activeIndex - 1); } }} onClick={(e) => { changeImage(activeIndex - 1) }}></i>}
                                            <ConditionalWrapper condition={props.DetailUrl} wrapper={children =>
                                                <a href={props.DetailUrl} target={props.LinkTarget} aria-label={translator.translate('sandhills.tradepubwebsite.mvc.viewdetails')}>
                                                    {children}
                                                </a>}
                                            >
                                                <span className='img-slider flex-container'>
                                                    {windowSize.isMobile ?
                                                        <>
                                                            <span id={'prev-img-' + props.ListingId + '-' + activeIndex == 0 ? props.ImageUrl.length - 1 : activeIndex - 1} className={movingLeft ? 'flex-item move-left' : 'flex-item'} style={{ transform: `translateX(${styleLeft})` }}  ><img loading="lazy" aria-hidden={true} onLoad={() => { setImageLoaded(true); setShowLoadingRing(false); }} src={activeIndex == 0 ? props.ImageUrl[props.ImageUrl.length - 1] : props.ImageUrl[activeIndex - 1]} className='listing-main-img' alt={props.AltText ? props.AltText : props.ListingTitle} /></span>
                                                            <span id={'current-img-' + props.ListingId + '-' + activeIndex} className={(activeIndex == maxImageCount ? 'max-image ' : '') + (movingLeft ? 'flex-item move-left' : movingRight ? 'flex-item move-right' : 'flex-item')} style={{ transform: `translateX(${styleMiddle})` }}  >
                                                                {activeIndex == maxImageCount && <span className='contain'><a href={props.DetailUrl} target={props.LinkTarget} aria-label={props.AltText} className='view-all' onClick={(e) => { gtmAlertPushEvent(gtmEventType.viewAllImagesClick) }}>{translator.translate('sandhills.seeall')} {props.ImageCount} {translator.translate('sandhills.photos')}</a></span>}
                                                                <img aria-hidden={false} onLoad={() => { setImageLoaded(true); setShowLoadingRing(false); }} src={props.ImageUrl[activeIndex]} className='listing-main-img' alt={props.AltText ? props.AltText : props.ListingTitle} />
                                                            </span>

                                                            {activeIndex + 1 == maxImageCount ?
                                                                <>
                                                                    <span id={'next-img-' + props.ListingId + '-' + activeIndex + 1} className={movingRight ? 'flex-item move-right max-image' : 'flex-item max-image'} style={{ transform: `translateX(${styleRight})` }} role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); gtmAlertPushEvent(gtmEventType.viewAllImagesClick); } }} onClick={(e) => { gtmAlertPushEvent(gtmEventType.viewAllImagesClick) }}>
                                                                        <a href={props.DetailUrl} target={props.LinkTarget} aria-label={props.AltText} className='view-all' onClick={(e) => { gtmAlertPushEvent(gtmEventType.viewAllImagesClick) }}>{translator.translate('sandhills.seeall')} {props.ImageCount} {translator.translate('sandhills.photos')}</a>
                                                                        <img onLoad={() => { setImageLoaded(true); setShowLoadingRing(false); }} src={props.ImageUrl[activeIndex + 1]} className={'listing-main-img disabled'} alt={props.AltText ? props.AltText : props.ListingTitle} />
                                                                    </span>
                                                                </>
                                                                : <span id={'next-img-' + props.ListingId + '-' + activeIndex == props.ImageUrl.length - 1 ? 0 : activeIndex + 1} className={movingRight ? 'flex-item move-right' : 'flex-item'} style={{ transform: `translateX(${styleRight})` }}  ><img loading="lazy" aria-hidden={true} onLoad={() => { setImageLoaded(true); setShowLoadingRing(false); }} src={activeIndex == props.ImageUrl.length - 1 ? props.ImageUrl[0] : props.ImageUrl[activeIndex + 1]} className='listing-main-img' alt={props.AltText ? props.AltText : props.ListingTitle} /></span>
                                                            }
                                                        </> :
                                                        <>
                                                            <span id={'prev-img-' + props.ListingId + '-' + activeIndex == 0 ? props.ImageUrl.length - 1 : activeIndex - 1} className={movingLeft ? 'flex-item move-left' : 'flex-item'}  ><img loading="lazy" aria-hidden={true} onLoad={() => { setImageLoaded(true); setShowLoadingRing(false); }} src={activeIndex == 0 ? props.ImageUrl[props.ImageUrl.length - 1] : props.ImageUrl[activeIndex - 1]} className='listing-main-img' alt={props.AltText ? props.AltText : props.ListingTitle} /></span>
                                                            <span id={'current-img-' + props.ListingId + '-' + activeIndex} className={(activeIndex == maxImageCount ? 'max-image ' : '') + (movingLeft ? 'flex-item move-left' : movingRight ? 'flex-item move-right' : 'flex-item')} >
                                                                {activeIndex == maxImageCount && <span className='contain'><a href={props.DetailUrl} target={props.LinkTarget} aria-label={props.AltText} className='view-all' onClick={(e) => { gtmAlertPushEvent(gtmEventType.viewAllImagesClick) }}>{translator.translate('sandhills.seeall')} {props.ImageCount} {translator.translate('sandhills.photos')}</a></span>}
                                                                <img aria-hidden={false} onLoad={() => { setImageLoaded(true); setShowLoadingRing(false); }} src={props.ImageUrl[activeIndex]} className='listing-main-img' alt={props.AltText ? props.AltText : props.ListingTitle} />
                                                            </span>

                                                            {activeIndex + 1 == maxImageCount ?
                                                                <>
                                                                    <span id={'next-img-' + props.ListingId + '-' + (activeIndex + 1)} className={movingRight ? 'flex-item move-right max-image' : 'flex-item max-image'} role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); gtmAlertPushEvent(gtmEventType.viewAllImagesClick); } }} onClick={(e) => { gtmAlertPushEvent(gtmEventType.viewAllImagesClick) }}>
                                                                        <a href={props.DetailUrl} target={props.LinkTarget} aria-label={props.AltText} className='view-all' onClick={(e) => { gtmAlertPushEvent(gtmEventType.viewAllImagesClick) }}>{translator.translate('sandhills.seeall')} {props.ImageCount} {translator.translate('sandhills.photos')}</a>
                                                                        <img onLoad={() => { setImageLoaded(true); setShowLoadingRing(false); }} src={props.ImageUrl[activeIndex + 1]} className={'listing-main-img disabled'} alt={props.AltText ? props.AltText : props.ListingTitle} />
                                                                    </span>
                                                                </>
                                                                :
                                                                <span id={'next-img-' + props.ListingId + '-' + activeIndex == props.ImageUrl.length - 1 ? 0 : activeIndex + 1} className={movingRight ? 'flex-item move-right' : 'flex-item'} ><img loading="lazy" aria-hidden={true} onLoad={() => { setImageLoaded(true); setShowLoadingRing(false); }} src={activeIndex == props.ImageUrl.length - 1 ? props.ImageUrl[0] : props.ImageUrl[activeIndex + 1]} className='listing-main-img' alt={props.AltText ? props.AltText : props.ListingTitle} /></span>
                                                            }</>
                                                    }
                                                </span>
                                            </ConditionalWrapper>
                                            {activeIndex < props.ImageUrl.length - 1 && <i className='fas fa-chevron-right arrow arrow-right' aria-label={translator.translate('sandhills.nextimage')} role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); changeImage(activeIndex + 1); } }} onClick={(e) => { changeImage(activeIndex + 1) }}></i>}</span>

                                    </>

                                    :
                                    <>
                                        {!props.IsCarouselRecommendedListing &&
                                            <>
                                                <div className={props.ShowBlur && props.LazyLoad && !props.ForceLoadImages ? 'listing-image-blur' : 'listing-image-main'} aria-hidden='true'>
                                                    {(props.ShowBlur && props.LazyLoad && !props.ForceLoadImages) ?
                                                    <LazyLoadImage className='listing-main-image' src={props.ImageUrl} alt={props.AltText ? props.AltText : props.ListingTitle} onLoad={() => setShowLoadingRing(false)} /> :
                                                    <img src={props.ImageUrl} className={'listing-main-image'} alt={props.AltText ? props.AltText : props.ListingTitle} onLoad={() => setShowLoadingRing(false)} />}
                                                </div>
                                                <ConditionalWrapper condition={props.DetailUrl} wrapper={children =>
                                                    <a href={props.DetailUrl} target={props.LinkTarget} aria-label={props.AltText}>
                                                        {children}
                                                        <span className='visually-hidden'>
                                                            <TranslationText tKey='sandhills.tradepubwebsite.mvc.viewdetails' />
                                                        </span>
                                                    </a>}
                                                >
                                                    {(props.ForceLoadImages || !props.LazyLoad) ?
                                                    <img onLoad={() => { setImageLoaded(true); setShowLoadingRing(false); }} src={props.ImageUrl} className={'listing-main-image'} alt={props.AltText ? props.AltText : props.ListingTitle} /> :
                                                    <LazyLoadImage className='listing-main-image' src={props.ImageUrl} alt={props.AltText ? props.AltText : props.ListingTitle} onLoad={() => setShowLoadingRing(false)} />}
                                                </ConditionalWrapper>
                                            </>
                                        }
                                    </>
                            }
                        }
                    </div>
                    {props.ImageUrl.length > 1 &&
                        <div className='image-selector'>
                            {props.ImageUrl.map((image, index) => {
                                return <i className={activeIndex == index ? 'fas fa-circle' : "far fa-circle"} aria-label={translator.translate('sandhills.viewimage') + " " + index} role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); changeImage(index); } }} onClick={() => changeImage(index)}></i>
                            })}
                        </div>
                    }
                    {!props.IsCarouselRecommendedListing &&
                        <div className='listing-image-footer'>
                            <>
                                <div className='listing-image-footer-left' aria-hidden='true'>
                                    {((props.ImageCount > 0) || (props.Image360Count > 0) || (props.VideoCount > 0)) &&
                                        <div className='listing-image-counts'>
                                            {props.ImageCount > 0 &&
                                                <>
                                                <LazyLoadImage visibleByDefault={(props.ForceLoadImages || !props.LazyLoad) ? 'true' : 'false'} src={routes.CDNBaseUrl + 'Images/Icons/Miscellaneous/pictures-white.png'} className='listing-image-icon' width='16' height='16' alt={translator.translate('sandhills.photos')} onLoad={() => setShowLoadingRing(false)} />
                                                    <span className='listing-image-icon-text'>{props.ImageCount}</span>
                                                </>}
                                            {props.Image360Count > 0 &&
                                                <>
                                                <LazyLoadImage visibleByDefault={(props.ForceLoadImages || !props.LazyLoad) ? 'true' : 'false'} src={routes.CDNBaseUrl + 'Images/Icons/Miscellaneous/pictures360-white.png'} className='listing-image-icon' width='16' height='16' alt={translator.translate('sandhills.360photos')} onLoad={() => setShowLoadingRing(false)} />
                                                    <span className='listing-image-icon-text'>{props.Image360Count}</span>
                                                </>}
                                            {props.VideoCount > 0 &&
                                                <>
                                                <LazyLoadImage visibleByDefault={(props.ForceLoadImages || !props.LazyLoad) ? 'true' : 'false'} src={routes.CDNBaseUrl + 'Images/Icons/Miscellaneous/videos-white.png'} className='listing-image-icon' width='16' height='16' alt={translator.translate('sandhills.videos')} onLoad={() => setShowLoadingRing(false)} />
                                                    <span className='listing-image-icon-text'>{props.VideoCount}</span>
                                                </>}
                                        </div>}
                                    {(props.IsAT || props.IsEF) && !props.IsAuctionResult ?
                                        <>
                                            {props.AuctionBid ?
                                                <div className='listing-image-price'>
                                                    <span className='spec-label'>{props.AuctionBidLabel}:</span>
                                                    <span className='auction-price'>{props.AuctionBid}</span>
                                                    <span className='quantity-label'> {props.QuantityLabel} {props.CalculatedPrice}</span>
                                                </div>
                                                :
                                                <div>&nbsp;</div>
                                            }
                                        </>
                                        :
                                        <>
                                            {!(props.IsAuctionResult && !currentUser?.IsAuthenticated) &&
                                                <>
                                                    {props.RetailPrice && showRetailPrice &&
                                                        <div className='listing-image-price'>
                                                            {props.RetailPrice}
                                                        </div>}
                                                    {props.AlternateRetailPrice && showRetailPrice &&
                                                        <div className='listing-image-price'>
                                                            {props.AlternateRetailPrice}
                                                        </div>}
                                                </>}
                                        </>}
                                </div>
                            </>
                            {(props.IsRecommendedListingListSearch || props.ShowWatchlist) &&
                                <div className='listing-image-buttons'>
                                    <a className='listings-watchlist-view-lnk watchlist-view' href={props.WatchlistUrl} title={props.WatchlistTitle}><i className='fas fa-list'></i></a>
                                    {getWatchlistButton()}
                                </div>}
                        </div>}
                </div>
                {props.children}
            </section>
        )
    );
};

export default ListingImage;